/* SCG teardown fixes, 10 Oct 2026. SCG-owned file: survives Horizon updates.
   Loaded from sections/header-group.json section scg_teardown.
   1. Product pages: delivery and returns line under the buy buttons (skipped on Custom Art, which has its own terms).
   2. Product pages: "Sold out" / "Unavailable" read as "Not available in this finish" (print on demand never sells out).
   3. Mobile product pages: chat bubble hides while the option buttons and Add to cart are on screen.
   4. Footer: Powered by Shopify becomes Powered by BaseWorks Consulting.
   5. Homepage: header logo h1 demoted so the hero headline is the only h1. */
(function () {
  var NOTE = 'Arrives in 4 to 10 business days. Damaged or wrong? We replace it.';
  var NA = 'Not available in this finish';
  var path = location.pathname;
  var isProduct = /\/products\//.test(path) && !/gift-card/.test(path);

  function shipNote() {
    if (!isProduct || /\/products\/custom-art/.test(path) || document.querySelector('.scg-ship-note, .scg-ca-upload')) return;
    var forms = [].slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    var form = forms.filter(function (f) { return !f.closest('sticky-add-to-cart, .sticky-add-to-cart, .quick-add, dialog'); })[0];
    if (!form) return;
    var p = document.createElement('p');
    p.className = 'scg-ship-note';
    p.textContent = NOTE;
    var host = form.closest('.buy-buttons-block, product-form-component') || form;
    host.parentNode.insertBefore(p, host.nextSibling);
  }

  function swapSoldOut(root) {
    if (!isProduct) return;
    var scope = root || document;
    var nodes = scope.querySelectorAll ? scope.querySelectorAll('.add-to-cart-text__content span, .visually-hidden, .variant-option__button-label, label span, button span') : [];
    [].forEach.call(nodes, function (el) {
      if (el.children.length) return;
      var t = el.textContent.trim();
      if (t === 'Sold out' || t === 'Unavailable') el.textContent = NA;
    });
  }

  function chatGuard() {
    if (!isProduct || !window.IntersectionObserver) return;
    var target = document.querySelector('variant-picker, .variant-picker, form[action*="/cart/add"]');
    if (!target) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var io = new IntersectionObserver(function (entries) {
      var on = entries[0].isIntersecting && mq.matches;
      document.documentElement.classList.toggle('scg-hide-chat', on);
    }, { threshold: 0.01 });
    io.observe(target);
  }

  function footerCredit() {
    var foot = document.querySelector('footer, .footer, [id*="footer"]');
    if (!foot) return;
    [].forEach.call(foot.querySelectorAll('a'), function (a) {
      if (/shopify\.com/.test(a.href) && /shopify/i.test(a.textContent)) {
        var wrap = a.parentNode;
        var link = document.createElement('a');
        link.href = 'https://baseworksconsulting.com';
        link.rel = 'noopener';
        link.textContent = 'Powered by BaseWorks Consulting';
        if (wrap && /powered by/i.test(wrap.textContent) && wrap.textContent.trim().length < 40) {
          wrap.textContent = '';
          wrap.appendChild(link);
        } else {
          a.replaceWith(link);
        }
      }
    });
  }

  function singleH1() {
    if (path !== '/') return;
    var hs = document.querySelectorAll('h1');
    if (hs.length < 2) return;
    [].forEach.call(hs, function (h) {
      if (h.closest('header, .header, #header-component')) {
        var d = document.createElement('div');
        d.className = h.className;
        d.innerHTML = h.innerHTML;
        h.replaceWith(d);
      }
    });
  }

  /* 6. Giveback line (10 Oct): footer seal and homepage story band. Source text in
     sections/footer-group.json (giveback_seal) and templates/index.json (story) still
     holds the old line; change it there the next time those files are edited. */
  var CMF = '1% of every purchase goes to The Centered Man Foundation, building a local community of men who work together to be authentic, develop themselves, and serve others.';
  function cmfLine() {
    [].forEach.call(document.querySelectorAll('.scg-seal p, .scg-story__txt p'), function (p) {
      if (/Centered Man Foundation, a Sonoma County nonprofit/.test(p.textContent)) p.textContent = CMF;
    });
  }

  function run() {
    cmfLine();
    shipNote();
    swapSoldOut();
    chatGuard();
    footerCredit();
    singleH1();
    if (isProduct && window.MutationObserver) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { shipNote(); swapSoldOut(); }, 60);
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
